<template>
  <div class="sub-layout">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data () {
    return {
      subList: [],
      activeKey: ''
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/variables.less';
.sub-layout {
  width: 100%;
  height: 100%;
}
</style>
